import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const MaximizeIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M14 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V4h-5a1 1 0 0 1-1-1ZM3 14a1 1 0 0 1 1 1v5h5a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z" />
      <path d="M21.707 2.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0Zm-11 11a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0Z" />
    </Icon>
  )
);
export default MaximizeIcon;
